module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__tracking-status",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Тип статуса",
      "name": "tracking_type",
      "id": "tracking_type",
      "data-vv-as": " ",
      "data-vv-name": "tracking_type",
      "data-vv-scope": "tracking_type",
      "error": _vm.errors.first('tracking_type')
    },
    model: {
      value: (_vm.status.tracking_type),
      callback: function($$v) {
        _vm.$set(_vm.status, "tracking_type", $$v)
      },
      expression: "status.tracking_type"
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(" Принят у отправителя (влияет на приём) ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v(" Промежуточный (влияет на приём) ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v(" Промежуточный (влияет на выдачу) ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v(" Промежуточный (не влияет на приём и выдачу) ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v(" Прибыл в пункт выдачи (влияет на приём) ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 6
    }
  }, [_vm._v(" Выдан получателю (влияет на выдачу) ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:4|max:255'),
      expression: "'required|min:4|max:255'"
    }],
    staticClass: "col-6",
    attrs: {
      "placeholder": "Введите название статуса",
      "label": "Название",
      "name": "name",
      "id": "name",
      "error": _vm.errors.first('name'),
      "data-vv-name": "name",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.status.name),
      callback: function($$v) {
        _vm.$set(_vm.status, "name", $$v)
      },
      expression: "status.name"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:0|max:5000'),
      expression: "'min:0|max:5000'"
    }],
    staticClass: "col-6",
    attrs: {
      "label": "Описание",
      "name": "description",
      "id": "description",
      "error": _vm.errors.first('description'),
      "data-vv-name": "description",
      "data-vv-as": ' ',
      "data-vv-scope": "description"
    },
    model: {
      value: (_vm.status.description),
      callback: function($$v) {
        _vm.$set(_vm.status, "description", $$v)
      },
      expression: "status.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-check', {
    staticClass: "col-6",
    attrs: {
      "label": "Выставлять статус 'Подтверждена' у заявки при установке статуса",
      "id": "confirm_deal",
      "value": 1,
      "error": _vm.errors.first('confirm_deal'),
      "data-vv-name": "confirm_deal",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.status.confirm_deal),
      callback: function($$v) {
        _vm.$set(_vm.status, "confirm_deal", $$v)
      },
      expression: "status.confirm_deal"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('z-color-selector', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "colors": _vm.colors,
      "label": "Выберите цвет",
      "data-vv-name": "color",
      "data-vv-as": ' ',
      "error": _vm.errors.first('color')
    },
    model: {
      value: (_vm.status.color),
      callback: function($$v) {
        _vm.$set(_vm.status, "color", $$v)
      },
      expression: "status.color"
    }
  })], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-864753dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/TrackingStatus.vue
// module id = 1215
// module chunks = 0